import { Action } from '../actions';
import {
    CLOSE_CREATIVE_PREVIEW_POPUP,
    SET_CREATIVE_PREVIEW_POPUP_DATA
} from '../actions/bannerCreativePreviewPopup';
import { BannerCreativePreviewPopupState } from '../typings/bannerCreativePreviewPopupState';

export const bannerCreativePreviewPopupReducer = (
    state: BannerCreativePreviewPopupState = {},
    action: Action
): BannerCreativePreviewPopupState => {
    switch (action.type) {
        case SET_CREATIVE_PREVIEW_POPUP_DATA:
            return {
                previewPopupVisibleType: action.previewPopupVisibleType,
                pcodeRenderData: action.bannerData,
                creativeUrl: action.creativeUrl,
                id: action.id
            };

        case CLOSE_CREATIVE_PREVIEW_POPUP:
            return {};

        default:
            return state;
    }
};
